//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment';

export default {
  name: 'DpCalendar',
  props: {
    // start: { type: Object, default: null },
    period: { type: Number, default: 0 },
    end: { type: Object, default: null },
    earliestTimestamp: { type: Number, default: null },
    rangeMode: { type: Boolean, default: false },
    range: { type: Object, default: null },
  },
  data() {
    return {
      currentYear: moment().year(),
      currentMonth: moment().month(),
      selectedDay: moment(),
      rangeAnchor: null,
      rangeStart: null,
      rangeEnd: null,
      rangeHover: null,
    };
  },
  computed: {
    currentMoment() {
      return moment().year(this.currentYear).month(this.currentMonth);
    },
    currentMonthAsText() {
      return this.currentMoment.format('MMMM');
    },
    calendarWeeks() {
      const startWeek = (this.currentMoment.startOf('month').week() - 1);
      const endWeek = startWeek + 6;

      const calendar = [];
      for (let week = startWeek; week < endWeek; week += 1) {
        const mapFunc = (n, i) => moment()
          .year(this.currentYear)
          .isoWeek(week)
          .startOf('isoWeek') // https://github.com/moment/moment/issues/5960
          .clone()
          .add(n + i, 'day');

        calendar.push({
          week,
          days: Array(7).fill(0).map(mapFunc),
        });
      }

      return calendar;
    },
    canNavigateForwards() {
      const now = moment();
      const current = `${now.year()}-${now.month()}`;
      const viewed = `${this.currentMoment.year()}-${this.currentMoment.month()}`;
      return current !== viewed;
    },
  },
  watch: {
    end: {
      handler(newAnchor) {
        if (newAnchor) {
          this.selectedDay = newAnchor.clone();
          this.updateSelectedDay();
        }
      },
      immediate: true,
    },
    range: {
      deep: true,
      immediate: true,
      handler(newRange) {
        if (newRange && newRange.start && newRange.end) {
          this.rangeStart = moment(newRange.start);
          this.rangeEnd = moment(newRange.end);
        }
      },
    },
  },
  methods: {
    clickDay(day) {
      if (this.isDisabled(day)) {
        return;
      }

      if (this.rangeMode && this.rangeAnchor) {
        if (day.isAfter(this.rangeAnchor)) {
          this.rangeStart = moment(this.rangeAnchor).startOf('day');
          this.rangeEnd = moment(day).endOf('day');
        } else {
          this.rangeStart = moment(day).startOf('day');
          this.rangeEnd = moment(this.rangeAnchor).endOf('day');
        }
        this.rangeAnchor = null;
        this.pushRangeChanges();
        return;
      }

      if (this.rangeMode) {
        this.rangeAnchor = day;
        this.rangeStart = null;
        this.rangeEnd = null;
      }

      this.selectedDay = day;

      this.pushChanges();
      this.updateSelectedDay();
    },
    updateSelectedDay() {
      if (this.selectedDay.month() !== this.currentMonth) {
        this.currentMonth = this.selectedDay.month();
      }
      if (this.selectedDay.year() !== this.currentYear) {
        this.currentYear = this.selectedDay.year();
      }
    },
    navigateMonth(direction) {
      if (direction === 'prev') {
        this.currentMonth -= 1;
      } else {
        this.currentMonth += 1;
      }

      if (this.currentMonth < 0) {
        this.currentMonth = 11;
        this.currentYear -= 1;
      } else if (this.currentMonth > 11) {
        this.currentMonth = 0;
        this.currentYear += 1;
      }
    },
    isActive(day) {
      if (this.rangeMode && this.rangeStart && this.rangeEnd) {
        return day.isSame(this.rangeStart, 'day') || day.isSame(this.rangeEnd, 'day');
      }
      return day.isSame(this.selectedDay, 'day');
    },
    isHighlighted(day) {
      let start;
      let end;

      if (this.rangeMode && this.rangeStart && this.rangeEnd) {
        start = this.rangeStart.unix();
        end = this.rangeEnd.unix();
      } else if (!this.period) {
        return false;
      } else {
        end = this.selectedDay.endOf('day').unix();
        start = end - (this.period / 1000);
      }

      const ts = day.unix();
      return ts >= start && ts < end;
    },
    isDisabled(day) {
      if (moment().isSame(day, 'day')) return false;

      // Check for a date in the future
      const now = moment().unix();
      const then = day.endOf('day').unix();
      if (now < then) return true;

      const ts = then * 1000;
      if (this.earliestTimestamp && this.earliestTimestamp > ts) return true;
      return false;
    },
    isToday(day) {
      if (this.rangeMode) return false;
      return moment().isSame(day, 'day');
    },
    isRangeAnchor(day) {
      if (!this.rangeMode || !this.rangeAnchor) return false;
      return this.rangeAnchor.isSame(day, 'day');
    },
    isTempRange(day) {
      if (!this.rangeMode || !this.rangeAnchor || !this.rangeHover) return false;
      const ts = day.unix();
      const anchorTs = this.rangeAnchor.unix();
      const hoverTs = this.rangeHover.unix();

      if (anchorTs > hoverTs && (ts >= hoverTs && ts < anchorTs)) {
        return true;
      }
      return ts <= hoverTs && ts > anchorTs;
    },
    pushChanges() {
      this.$emit('change', {
        end: this.selectedDay,
      });
    },
    pushRangeChanges() {
      this.$emit('change-range', {
        start: this.rangeStart,
        end: this.rangeEnd,
      });
    },
    clearRange() {
      this.rangeAnchor = null;
      this.rangeStart = null;
      this.rangeEnd = null;
      this.selectedDay = null;
    },
  },
};
